/**
 * Fall from Grace market icon configuration
 * Centralized to ensure consistency across all FFG displays
 */

/** Path to the FFG broken crown icon in the public folder */
export const FFG_ICON_URL = "/fallfromgrace.png"
